import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { Loader2 } from 'lucide-react'
import { useAuthStore } from '@/stores/auth-store'
import AppLayout from './AppLayout'

export default function ProtectedLayout() {
  const { user, isAuthenticated, checkAuth } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()
  const [sessionReady, setSessionReady] = useState(false)

  useEffect(() => {
    checkAuth().finally(() => setSessionReady(true))
  }, [checkAuth])

  const needsLogin = !isAuthenticated || (isAuthenticated && !user?.tenantCode)

  useEffect(() => {
    if (sessionReady && needsLogin) {
      const returnUrl = encodeURIComponent(location.pathname + location.search)
      navigate(`/login?returnUrl=${returnUrl}`, { replace: true })
    }
  }, [sessionReady, needsLogin, navigate, location])

  if (!sessionReady) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  if (needsLogin) return null

  return <AppLayout />
}
